export default __webpack_public_path__ + "static/media/beach.a582fa14.jpg";